import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Close } from '../assets/closeBtn.svg';
import { ReactComponent as AddIcon } from '../assets/addIcon.svg';
import { ReactComponent as DeleteIcon } from '../assets/deleteIcon.svg';
import axios from 'axios';
import config from "../config";
import Header from './Header'; // Добавляем импорт Header
import { useSelector } from 'react-redux'; // Подключаем useSelector для Redux
import LoaderInside from './LoaderInside';

const GENDER_TYPES = {
    MALE: 'Мужской',
    FEMALE: 'Женский'
};

const CONTENT_TYPES = {
    TEXT: 'text',
    RESOURCE: 'resource'
};

// Список разделов, которые открываются напрямую
const DIRECT_SECTIONS = [
    'Инструкция для новичка',
    'Правила марафона',
    'Регламент сдачи отчётов',
    'Регламент общения в чате',
    'Условия розыгрыша'
];

const DetailPage = () => {
    const { title, buttonText } = useParams();
    const navigate = useNavigate();
    const [contentBlocks, setContentBlocks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const adminMode = useSelector((state) => state.adminMode.adminMode);
    const reduxGender = useSelector((state) => state.user.gender);
    const [selectedGender, setSelectedGender] = useState(reduxGender || GENDER_TYPES.MALE);
    const initData = window.Telegram.WebApp.initData;
    const [headerImage, setHeaderImage] = useState('');

    // Определяем, является ли текущий раздел прямым
    const isDirectSection = DIRECT_SECTIONS.includes(title);

    // Определяем, какой пол использовать для запросов
    const genderToUse = adminMode ? selectedGender : reduxGender;

    const handleSave = () => {
        const dataToSend = {
            title,
            initData,
            buttonText,
            contentBlocks,
            headerImage,
            gender: genderToUse
        };

        axios.post(`${config.API_BASE_URL}/upgrade/save-detail`, dataToSend)
            .then((response) => {
                if (response.data.success) {
                    alert('Данные сохранены');
                } else {
                    alert('Ошибка сохранения');
                }
            })
            .catch(() => alert('Ошибка при сохранении данных'));
    };

    const handleClose = () => {
        // Если это прямой раздел, возвращаемся на главную страницу Upgrade
        if (isDirectSection) {
            navigate('/upgrade');
        } else {
            // Иначе возвращаемся на промежуточную страницу
            navigate(`/upgrade/${encodeURIComponent(title)}`);
        }
    };

    useEffect(() => {
        axios.get(`${config.API_BASE_URL}/upgrade/get-detail?title=${title}&button=${buttonText}&gender=${genderToUse}`)
            .then(({ data }) => {
                if (data.success) {
                    setContentBlocks(data.contentBlocks || []);
                    setHeaderImage(data.headerImage || '');
                } else {
                    console.error('Ошибка загрузки данных:', data);
                }
            })
            .catch(() => console.error('Ошибка при запросе данных'))
            .finally(() => setIsLoading(false));
    }, [title, buttonText, genderToUse]);

    const addContentBlock = (type) => {
        const newBlock = {
            id: Date.now(),
            type,
            content: '',
            title: type === CONTENT_TYPES.TEXT ? '' : undefined
        };
        setContentBlocks([...contentBlocks, newBlock]);
    };

    const updateContentBlock = (id, field, value) => {
        setContentBlocks(contentBlocks.map(block =>
            block.id === id ? { ...block, [field]: value } : block
        ));
    };

    const removeContentBlock = (id) => {
        setContentBlocks(contentBlocks.filter(block => block.id !== id));
    };

    const renderResource = (resource) => {
        if (!resource) return null;

        const isVideo = /\.(mp4|webm)$/i.test(resource);
        const isAudio = /\.(mp3|wav|ogg)$/i.test(resource);
        const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(resource);

        if (isVideo) {
            return (
                <div className="resource-container">
                    <video controls>
                        <source src={resource} type="video/mp4" />
                    </video>
                </div>
            );
        }

        if (isAudio) {
            return (
                <div className="resource-container">
                    <audio controls>
                        <source src={resource} />
                    </audio>
                </div>
            );
        }

        if (isImage) {
            return (
                <div className="resource-container">
                    <img src={resource} alt="Изображение" />
                </div>
            );
        }

        return (
            <div className="resource-container">
                <a href={resource} target="_blank" rel="noopener noreferrer">
                    {resource}
                </a>
            </div>
        );
    };

    if (isLoading) {
        return <div className="main-load"><LoaderInside /></div>;
    }

    return (
        <>
            <Header />
            <div className="detail-page">
                <div className='detail-head'>
                    <div className="close-btn" onClick={handleClose}>
                        <Close />
                    </div>
                    <h2>{isDirectSection ? title : `${title} / ${buttonText}`}</h2>
                </div>
                <div className="detail-content">

                    {adminMode ? (
                        <div className="admin-content-blocks">
                            <div className="header-image-section">
                                <label>Ссылка на заглавное изображение:</label>
                                <input
                                    className='input'
                                    type="text"
                                    value={headerImage}
                                    onChange={(e) => setHeaderImage(e.target.value)}
                                    placeholder="URL изображения"
                                />
                            </div>

                            {headerImage && (
                                <div className="header-image-preview">
                                    <img src={headerImage} alt="Заглавное изображение" />
                                </div>
                            )}

                            {contentBlocks.map((block) => (
                                <div key={block.id} className="content-block">
                                    {block.type === CONTENT_TYPES.TEXT ? (
                                        <div className="text-block-with-title">
                                            <input
                                                className='input text-title-input'
                                                type="text"
                                                value={block.title || ''}
                                                onChange={(e) => updateContentBlock(block.id, 'title', e.target.value)}
                                                placeholder="Заголовок блока (необязательно)"
                                            />
                                            <textarea
                                                className='textarea'
                                                value={block.content}
                                                onChange={(e) => updateContentBlock(block.id, 'content', e.target.value)}
                                                placeholder="Введите текст"
                                            />
                                        </div>
                                    ) : (
                                        <input
                                            className='input'
                                            type="text"
                                            value={block.content}
                                            onChange={(e) => updateContentBlock(block.id, 'content', e.target.value)}
                                            placeholder="Ссылка на ресурс"
                                        />
                                    )}
                                    <button
                                        className="delete-block-btn"
                                        onClick={() => removeContentBlock(block.id)}
                                    >
                                        <DeleteIcon />
                                    </button>
                                </div>
                            ))}

                            <div className="add-block-buttons">
                                <button
                                    className="add-block-btn"
                                    onClick={() => addContentBlock(CONTENT_TYPES.TEXT)}
                                >
                                    <AddIcon /> Добавить текст
                                </button>
                                <button
                                    className="add-block-btn"
                                    onClick={() => addContentBlock(CONTENT_TYPES.RESOURCE)}
                                >
                                    <AddIcon /> Добавить ресурс
                                </button>
                            </div>

                            <button className="button-sv" onClick={handleSave}>Сохранить</button>
                        </div>
                    ) : (
                        <div className="user-content-blocks">
                            {headerImage && (
                                <div className="header-image">
                                    <img src={headerImage} alt="Заглавное изображение" />
                                </div>
                            )}

                            {contentBlocks.map((block, index) => (
                                <div key={index} className="content-block">
                                    {block.type === CONTENT_TYPES.TEXT ? (
                                        <div className="text-block-container">
                                            {block.title && <div className="text-block-title">{block.title}</div>}
                                            <p className={block.title ? "with-title" : ""}>{block.content}</p>
                                        </div>
                                    ) : (
                                        renderResource(block.content)
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default DetailPage;
